





















































































  import { Vue, Component, Prop } from 'vue-property-decorator';
  import XLSX from 'xlsx';  
  import { EUserStatus, EUserGroup } from "@/components/shared/types";
  import { User } from "@/components/User";
  import { L } from "@/common/filters";
  import { ICodeList } from "@/components/map/types";
  import WebSocket from "../websocket";

  @Component({
    watch: {
      pagination: {
        deep: true,
        handler() {
          //this.getOnlineUsers();
        }
      }
    }
  })
  export default class OnlineUsers extends Vue {
    @Prop({
      default : null
    }) data: WebSocket;

    WebSocket:WebSocket = null;

    RowsPerPage = [15];
    showMini:boolean = true;
    srhKwd:string = null;
    loading:boolean = false;

    pagination:any = {};

    get headers() {
      return [{
          text: L(['name',' - ', '^surname$']),
          align: 'left',
          value: 'FullName'
        },{
          text: L('email'),
          align: 'left',
          value: 'Email'
        },{
          text: L('organization'),
          align: 'left',
          value: 'Email'
        }];
    }
    
    get User() : User {
      return this.$store.getters.User;
    }

    get language() : string {
      return this.$store.getters.Language;
    };

    created() {
      if (this.data) {
        this.WebSocket = this.data;
      } else {
        this.WebSocket = new WebSocket();
        this.WebSocket.open();
      }
    }

    mounted() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.WebSocket.updateOnlineUserList = true;
      this.getOnlineUsers();
    }

    beforeDestroy() {
      this.WebSocket.updateOnlineUserList = false;
    }

    getOnlineUsers() {
      try {
        let data: any = {
          type: 'list_users',
          offset: (this.pagination.page - 1) * this.pagination.rowsPerPage,
          limits: this.pagination.rowsPerPage
        };
        if (!!this.srhKwd) {
          data.q = this.srhKwd;
        }
        this.WebSocket.send(data);
      } catch (error) {}
    };

    searchUsers() {
      this.srhKwd = this.srhKwd ? this.srhKwd.trim() : null;
      this.WebSocket.OnlineUsers = [];
      this.pagination.page = 1;
      this.getOnlineUsers();
    }

    async exportToExcel() {
      try {
        let lists = this.WebSocket.OnlineUsers.map((list) => {
          let gn = EUserGroup[list.group];
          gn = gn.charAt(0).toLowerCase() + gn.slice(1);
          let orgAbbr = list.org_abbr || null;
          let orgName = list.org_name || null;
          if (orgName && orgAbbr) {
            orgName += ' (' + orgAbbr + ')';
          } else if (!orgName && orgAbbr) {
            orgName = orgAbbr;
          }
          let on = list.org_name && list.org_
          return {
            "ชื่อ" : list.name,
            "นามสกุล": list.surname,
            "อีเมล์": list.email,
            "เบอร์มือถือ": list.mobile,
            "กลุ่มผู้ใช้": L(gn),
            "หน่วยงาน": orgName
          };
        });
        let ws = XLSX.utils.json_to_sheet(lists);
        let wb = XLSX.utils.book_new(); // make Workbook of Excel
        XLSX.utils.book_append_sheet(wb, ws, 'รายชื่อผู้ใช้') ;
        XLSX.writeFile(wb, 'gisagro-onlineusers.xlsx') ;
        this.loading = false;
      } catch (error) {
        this.loading = false;
console.log(error);
      }
    }
    
    showUserProfile(user:User) {
      this.$emit('changeMe',{
        menu: {
          name: 'show_profile',
          title: user.FullName
        },
        data: user
      });
    }
    
    listUsers() {
      this.$emit('changeMe',{
        menu: {
          name: 'admin_users',
          icon: 'mdi-account-multiple',
          title: 'adminUser'
        }
      });
    }
    
    addUser() {
      this.$emit('changeMe',{
        menu: {
          name: 'admin_adduser',
          icon: 'mdi-account-plus-outline',
          title: 'registerUsers'
        }
      });
    }

    closeMe() {
      this.$emit('closeRightToc');
    }
  }
